import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["name", "category", "submitButton", "nameError", "categoryError"]

  connect() {
    this.boundHideNameError = this.hideNameError.bind(this);
    this.boundHideCategoryError = this.hideCategoryError.bind(this);
    this.nameTarget.addEventListener("input", this.boundHideNameError);
    this.initCategory();
  }

  disconnect() {
    this.nameTarget.removeEventListener("input", this.boundHideNameError);
    if (this.categoryTarget) {
      this.categoryTarget.removeEventListener("change", this.boundHideCategoryError);
    }
    if (this.categoryChoices) {
      this.categoryChoices.destroy();
    }
  }

  validateForm(event) {
    const hasName = this.nameTarget.value.trim().length > 0;
    const hasCategory = this.categoryTarget.value !== '';

    let isValid = true;

    if (!hasName) {
      event.preventDefault();
      this.showNameError();
      isValid = false;
    }

    if (hasName && !hasCategory) {
      event.preventDefault();
      this.showCategoryError();
      isValid = false;
    }

    return isValid;
  }

  showNameError() {
    this.nameErrorTarget.classList.remove("is-hidden");
  }

  hideNameError() {
    this.nameErrorTarget.classList.add("is-hidden");
  }

  showCategoryError() {
    this.categoryErrorTarget.classList.remove("is-hidden");
  }

  hideCategoryError() {
    this.categoryErrorTarget.classList.add("is-hidden");
  }

  initCategory() {
    fetch("/categories.json")
      .then(response => response.json())
      .then(data => {
        this.setupCategory(data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
  }

  setupCategory(categories) {
    this.categoryChoices = new Choices(this.categoryTarget, {
      choices: categories,
      searchFields: ['label']
    });

    // Listen for category selection changes
    this.categoryTarget.addEventListener('change', this.boundHideCategoryError);
  }
}
